// _neu_generated_code__dont_modify_directly_
/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE CLASS NAME*/
//CORE_REFERENCE_IMPORTS
//append_imports_start

import {
  Component,
  EventEmitter,
  Injector,
  Input,
  Output,
} from '@angular/core'; //_splitter_
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'; //_splitter_
import { SDPageCommonService } from 'app/n-services/sd-page-common.service'; //_splitter_
import { SDBaseService } from 'app/n-services/SDBaseService'; //_splitter_
import { NeuServiceInvokerService } from 'app/n-services/service-caller.service'; //_splitter_
//append_imports_end

@Component({
  selector: 'bh-memberSelectModal',
  templateUrl: './memberSelectModal.template.html',
  providers: [
    //appendnew_element_providers
  ],
})
export class memberSelectModalComponent {
  @Input('usersList')
  public usersList: any = undefined;
  @Output('selectedUser')
  public selectedUser: any = new EventEmitter<any>();
  page: any = { dep: {} };
  constructor(
    private __page_injector__: Injector,
    private sdService: SDBaseService,
    public __serviceInvoker__: NeuServiceInvokerService
  ) {
    this.__page_injector__.get(SDPageCommonService).addPageDefaults(this.page);
    this.registerListeners();
    //appendnew_element_inject
  }

  ngOnInit() {
    const bh: any = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);
    {
      this.sd_gKAvHb3namDNVY1B(bh);
    }
  }

  private registerListeners() {
    let bh = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);

    //append_listeners
  }

  sd_gKAvHb3namDNVY1B(bh) {
    try {
      bh = this.sd_MIpnPNAunfUBlSRE(bh);
      //appendnew_next_sd_gKAvHb3namDNVY1B
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_gKAvHb3namDNVY1B');
    }
  }

  onClickUser(user: any = undefined, ...others) {
    let bh: any = {};
    try {
      bh = this.__page_injector__
        .get(SDPageCommonService)
        .constructFlowObject(this);
      bh.input = { user };
      bh.local = {};
      bh = this.sd_v0sbfr9ZB9q7uK2r(bh);
      //appendnew_next_onClickUser
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_DzdIsCO0aUATdh27');
    }
  }
  //appendnew_flow_memberSelectModalComponent_start

  sd_MIpnPNAunfUBlSRE(bh) {
    try {
      bh = this.sd_L8m7bwTgxhcUoZKG(bh);
      //appendnew_next_sd_MIpnPNAunfUBlSRE
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_MIpnPNAunfUBlSRE');
    }
  }

  sd_L8m7bwTgxhcUoZKG(bh) {
    try {
      this.page.data = this.__page_injector__.get(MAT_DIALOG_DATA);

      bh = this.sd_ROazaHR1slbPyXQF(bh);
      //appendnew_next_sd_L8m7bwTgxhcUoZKG
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_L8m7bwTgxhcUoZKG');
    }
  }

  sd_ROazaHR1slbPyXQF(bh) {
    try {
      const page = this.page;
      page.usersList = page.data;

      page.isUserListEmpty = page.usersList.length <= 0;
      //appendnew_next_sd_ROazaHR1slbPyXQF
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_ROazaHR1slbPyXQF');
    }
  }

  sd_v0sbfr9ZB9q7uK2r(bh) {
    try {
      const page = this.page;

      page.selectedUser = bh.input.user;
      bh = this.sd_gsqZfEVEBypK7s6W(bh);
      //appendnew_next_sd_v0sbfr9ZB9q7uK2r
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_v0sbfr9ZB9q7uK2r');
    }
  }

  sd_gsqZfEVEBypK7s6W(bh) {
    try {
      const _dialogRef = this.__page_injector__.get(MatDialogRef);
      _dialogRef.close(this.page.selectedUser);

      //appendnew_next_sd_gsqZfEVEBypK7s6W
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_gsqZfEVEBypK7s6W');
    }
  }

  //appendnew_node

  ngOnDestroy() {
    const bh: any = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);
    this.__page_injector__.get(SDPageCommonService).deletePageFromMap(this);
  }

  // error_handler_slot
  private errorHandler(bh, e, src): Promise<any> {
    console.error(e);
    bh.error = e;
    bh.errorSource = src;
    throw e;
  }
  //appendnew_flow_memberSelectModalComponent_Catch
}
